

export const GroupedObjectSelector = (props) => {
    let {
		groupedOptions,  // Options that are grouped instead of regular
        onChange,        // The "real" HTML selector onChange event (runs last)
        defaultValue,
        defaultSelected,
	} = props;

    if(defaultValue == null){
        defaultValue = "";
    }


    let getOptions = function(group){
        return group.options.map(survey => {
            return <option key={survey.id} value={survey.id} selected={defaultSelected==survey.id} >
                {survey.name}
            </option>
        })
    }


    let groupedOptionsList = groupedOptions.map(group => {
        if(group.name == ""){
            return getOptions(group)
        } else {
            return (
                <optgroup label={group.name} key={group.name}>
                    {getOptions(group)}
                </optgroup>
            );
        }
    } )

    return (
        <select className="form-select" onChange={onChange}>
            <option> {defaultValue} </option>
            {groupedOptionsList}
        </select>
    )
}
